import React, { useEffect, useState } from "react"
import axios from "axios"
import { site } from "../../../../../utils/site"
import { navigate } from "gatsby"
import Section from "../../../../core/layout/main/section/Section"
import RhJobAdResultsSection from "../../../rh/job-ad/rh-job-ad-results/RhJobAdResultsSection"
import RhJobAdSearchFormSection from "../../../rh/job-ad/rh-job-ad-search-form/RhJobAdSearchFormSection"
import RhSearchResult from "./rh-search-result/RhSearchResult"
import CtxHeroSection from "../ctx-hero-section/CtxHeroSection"
import Button from "../../blocks/button/Button"
import SearchResultListBlock from "./section-search-result/SearchResultListBlock"
import GrpSearchResultList from "./grp-section-search-result/GrpSearchResultList"

function renderGcOrComPage(imageVideo, queryTerm, searchResult, fieldName) {
  let rubriques = []
  if (searchResult && fieldName in searchResult) {
    const rubrique = { title: "Solutions", items: [] }
    for (const product of searchResult[fieldName]) {
      rubrique.items.push(product)
    }
    rubriques.push(rubrique)
  }

  if (searchResult.page) {
    const rubrique = { title: "Autre", items: [] }
    for (const page of searchResult.page) {
      rubrique.items.push(page)
    }
    rubriques.push(rubrique)
  }
  return (
    <>
      <CtxHeroSection
        image={imageVideo}
        imgSrc="https://media.paritel.fr/paritel-www-dev/assets/fibre_d890ae8ce2.jpg"
      >
        <div className="row clearfix hero_recherche container flex items-center">
          <div className="spacer height-120"></div>
          <div className="column full flex flex-col justify-center items-start fade-in-bottom">
            <h1
              style={{ color: "rgb(247, 247, 247)" }}
              className="font-semibold"
            >
              Résultats de recherche <br />
              pour &ldquo;{queryTerm}&rdquo;
            </h1>
          </div>
          <div class="spacer height-120"></div>
        </div>
      </CtxHeroSection>
      <Section
        classNames="renderGcOrComPage pbl-6"
        container
      >
        {rubriques.length > 0 ? (
          rubriques.map((s) => (
            <div key={s.title}>
              <h2 className="mbl-6">{s.title}</h2>
              <div className="row justify-content-center gap-3 loadin loaded">
                {s.items.map((i) => (
                  <div
                    key={i.title}
                    className="card col flex flex-direction-column gap-2 p-3 secondary-background-color no-shadow min-w-40 max-w-50 w-100"
                  >
                    <h3>{i.title}</h3>
                    <p>{i.description}</p>
                    <Button
                      aspect={"classique"}
                      color={"primary"}
                      onClick={() => navigate(i.route)}
                    >
                      Découvrir
                    </Button>
                  </div>
                ))}
              </div>
            </div>
          ))
        ) : (
          <div className="row justify-content-center gap-3 loadin loaded">
            <div>
              <h3 className="mb-3">
                Pas de résultats pour votre recherche, mais vous pouvez toujours
                retourner à la page d’accueil
              </h3>
              <Button
                aspect={"classique"}
                color={"primary"}
                to="/"
              >
                Retourner à la page d'accueil
              </Button>
            </div>
          </div>
        )}
      </Section>
    </>
  )
}

const SearchResultSection = ({ imageVideo }) => {
  const isBrowser = typeof window !== "undefined"
  let queryTerm
  if (isBrowser) {
    const urlParams = new URLSearchParams(window?.location.search)
    console.log(urlParams)
    queryTerm = urlParams.get("q")
  }

  const [searchResult, setSearchResult] = useState(false)

  useEffect(() => {
    let res
    async function fetchData() {
      res = await axios.get(process.env.GATSBY_NEST_BASE_URL + "/search", {
        params: { site: site, q: queryTerm },
      })
      setSearchResult(res?.data || false)
    }
    fetchData()
  }, [])

  if (site === "gc") {
    return renderGcOrComPage(imageVideo, queryTerm, searchResult, "Produits_GC")
  }

  if (site === "com") {
    return renderGcOrComPage(
      imageVideo,
      queryTerm,
      searchResult,
      "Produits_Com"
    )
  }

  if (site === "rh") {
    return <RhSearchResult urlTermFilter={queryTerm} imageVideo={imageVideo}/>
    return (
      <>
        <RhJobAdSearchFormSection
          showCitySearchField={true}
          showJobSearchField={true}
          showContractTypeSearchField={true}
          title={"Découvrez nos offres d'emplois"}
        />
        <RhJobAdResultsSection poste={queryTerm} />
      </>
    )
  }

  if (site === "blog") {
    return (
      <SearchResultListBlock
        articles={searchResult}
        term={queryTerm}
      />
    )
  }

  if (site === "grp") {
    return (
      <GrpSearchResultList
        pages={searchResult}
        term={queryTerm}
      />
    )
  }

  return (
    <div>
      SearchResults : <br /> <pre>{JSON.stringify(searchResult, null, 2)}</pre>
    </div>
  )
}

export const name = "SearchResultSection"

export const init = (componentData, pageContext) => {
  return <SearchResultSection imageVideo={componentData.imageVideo} />
}

export default SearchResultSection
